/** A reproducible rain field at an absolute phase, in seconds. */
export function rainFrame({
  width,
  height,
  count,
  wind,
  lineScale,
  seed,
  phase,
}: {
  width: number
  height: number
  count: number
  wind: number
  lineScale: number
  seed: number
  phase: number
}) {
  const random = (index: number, salt: number) => {
    let n = (seed ^ Math.imul(index + 1, 0x9e3779b1) ^ Math.imul(salt, 0x85ebca6b)) >>> 0
    n = Math.imul(n ^ (n >>> 16), 0x7feb352d)
    n = Math.imul(n ^ (n >>> 15), 0x846ca68b)
    return ((n ^ (n >>> 16)) >>> 0) / 4294967296
  }
  const mod = (value: number, range: number) => ((value % range) + range) % range
  return Array.from({ length: count }, (_, index) => {
    const scale = random(index, 1)
    const vy = 0.25 + 0.3 * scale
    const len = (15 + 20 * scale) * lineScale
    const elapsed = phase * 1000
    return {
      x: mod(random(index, 2) * (width + 80) + wind * elapsed, width + 80) - 40,
      y: mod(random(index, 3) * (height + len) + vy * elapsed, height + len),
      vy,
      vx: wind,
      len,
      alpha: 0.06 + 0.12 * scale,
    }
  })
}
